import {
  Injectable,
  Injector,
  Signal,
  inject,
  runInInjectionContext,
} from '@angular/core';
import { Auth, user, type User } from '@angular/fire/auth';
import { toSignal } from '@angular/core/rxjs-interop';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class CurrentUserService {
  private readonly auth = inject(Auth);
  private readonly injector = inject(Injector);

  readonly currentUser: Signal<User | null> = toSignal(this.currentUser$(), {
    initialValue: null,
  });

  currentUser$(): Observable<User | null> {
    return runInInjectionContext(this.injector, () => user(this.auth));
  }
}
